import type { ComponentInternalInstance } from 'vue';

let app: ComponentInternalInstance | null = null;

export function setAppInstance(instance: ComponentInternalInstance | null) {
  app = instance;
}

export function getAppInstance(): ComponentInternalInstance | null {
  return app;
}
